import axios from "@/helpers/axios";
const commonURL = "/locations";

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    async getRiderLocationByOrderId({ rootGetters, dispatch }, payload) {
      try {
        const result = await axios.get(`${commonURL}/${payload}`);
        return result.data;
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
  },
  getters: {},
};
